<template>
  <div>
    <!--vs-card>
      <FormCancelamento :vistoria="false" @filtro="makeFiltro"></FormCancelamento>
    </vs-card-->
    <Filtro :vistoria="false" @filtro="makeFiltro"></Filtro>
    <vs-card>
      <List
        :vistoria="true"
        :filtro="filtro"
        :realizaFiltro="realizaFiltro"
        @filtroOk="finalizaFiltro"
        :subjectPermission="subjectPermission"
      ></List>
    </vs-card>
  </div>
</template>

<script>
import List from "./../../lists/ListCancelamentos";
import Filtro from "./../../filtros/FiltroCancelamentos";
export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      valor: "",
      subjectPermission: "Cancelamento",
    };
  },
  methods: {
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
  },
  mounted() {},
  components: {
    List,
    Filtro,
  },
};
</script>
<style scoped>
</style>


